module.exports = __webpack_public_path__ + "static/media/monta.c0a9db6d.png";